/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!***************************************************************!*\
  !*** ./resources/scripts/sections/video-banner-popup/main.js ***!
  \***************************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "videoBannerPopup": () => (/* binding */ videoBannerPopup)
/* harmony export */ });
var videoBannerPopup = function videoBannerPopup() {
  var getTargetVideo = function getTargetVideo($htmlVideoContainer) {
    if ($htmlVideoContainer) {
      var targetVideo = $htmlVideoContainer.querySelector(".mobile-video");
      if (window.innerWidth > 1023) {
        targetVideo = $htmlVideoContainer.querySelector(".desktop-video");
      }
      return targetVideo;
    } else {
      //console.log('No $htmlVideoContainer passed to function');
    }
  };
  var $videoBannerSections = document.querySelectorAll("section.video-banner");
  if ($videoBannerSections) {
    $videoBannerSections.forEach(function ($videoBannerSection) {
      //Find popup, may not be present as toggleable in section
      var $popup = $videoBannerSection.querySelector(".video-banner__popup");
      var $popupTriggers = $videoBannerSection.querySelectorAll(".video-banner__popup-trigger");
      var $popupBackground = $videoBannerSection.querySelector(".video-banner__popup-background");
      if ($popup && $popupTriggers && $popupBackground) {
        var $htmlVideoContainer = $popup.querySelector(".video-file-container");
        if ($htmlVideoContainer) {
          var $pauseDisplay = $htmlVideoContainer.querySelector(".pause-display");
          var $playDisplay = $htmlVideoContainer.querySelector(".play-display");
          if ($pauseDisplay && $playDisplay) {
            $popupTriggers.forEach(function ($popupTrigger) {
              $popupTrigger.addEventListener("click", function () {
                $popup.classList.remove("hidden");

                //make video play on opening
                var targetVideo = getTargetVideo($htmlVideoContainer);
                if (targetVideo) {
                  $playDisplay.classList.add("hidden");
                  $playDisplay.classList.remove("flex");
                  $pauseDisplay.classList.remove("hidden");
                  $pauseDisplay.classList.add("flex");
                  targetVideo.play();
                } else {
                  //console.log("couldnt get target video when opening popup");
                }
              });
            });

            //bind close of popup
            $popupBackground.addEventListener("click", function () {
              $popup.classList.add("hidden");

              //pause relevant video if playing
              var targetVideo = getTargetVideo($htmlVideoContainer);
              if (targetVideo) {
                if (!$pauseDisplay.classList.contains("hidden")) {
                  $playDisplay.classList.remove("hidden");
                  $playDisplay.classList.add("flex");
                  $pauseDisplay.classList.add("hidden");
                  $pauseDisplay.classList.remove("flex");
                  targetVideo.pause();
                }
              } else {
                //console.log("couldnt find targetVideo when trying to close popup - unable to determine if need to stop video");
              }
            });
            $htmlVideoContainer.addEventListener("click", function () {
              //Clicking on video plays / pauses it
              var targetVideo = getTargetVideo($htmlVideoContainer);
              if (targetVideo) {
                if ($playDisplay.classList.contains("hidden")) {
                  $playDisplay.classList.remove("hidden");
                  $playDisplay.classList.add("flex");
                  $pauseDisplay.classList.add("hidden");
                  $pauseDisplay.classList.remove("flex");
                  targetVideo.pause();
                } else {
                  $playDisplay.classList.add("hidden");
                  $playDisplay.classList.remove("flex");
                  $pauseDisplay.classList.remove("hidden");
                  $pauseDisplay.classList.add("flex");
                  targetVideo.play();
                }
              } else {
                //console.log("couldnt identify target video");
              }
            });
          } else {
            //console.log("Couldnt find Play / Pause display buttons");
          }
        }
      }
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (videoBannerPopup);
document.addEventListener("DOMContentLoaded", videoBannerPopup);
/******/ })()
;